module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_vm._v("\n\t\t\t\t\t\tdefault body\n\t\t\t\t\t")]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('button', {
      staticClass: "modal-default-button btn btn-default",
      on: {
        "click": _vm.close
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
      staticClass: "modal-default-button btn btn-default",
      on: {
        "click": _vm.confirm
      }
    }, [_vm._v("确定")])]
  })], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00c013e1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/dialog.vue
// module id = 89
// module chunks = 0